<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FAX 命令</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">设置 exchaincli</a></p>
          <!-- <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">FAX 客户端</div>
      <div id="box1" class="p4">FAX 命令</div>
      <div class="p3"><span>exchaincli</span> 是使您能够与运行在 FaxChain 网络上的节点进行交互的工具，无论您是否自己运行它。让我们正确设置它。为了安装它，请按照安装程序。</div>
      <div id="box2" class="p4">设置 exchaincli</div>
      <div class="p3">用于设置的主要命令 <span>exchaincli</span> 如下：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config < flag > < value ></div>
        </div>
      </div>
      <div class="p3">它允许您为每个给定标志设置默认值。</div>
      <div class="p3">首先，设置要连接的全节点地址：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config node < host >:< port ></div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0"># example: exchaincli config node https://exchaintesttmrpc.fax.org (testnet)</div>
          <div style="padding:5px 0 5px 0"># example: exchaincli config node https://exchaintmrpc.fax.org (mainnet)</div>
        </div>
      </div>
      <div class="p3">或以下任何地址端口：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0"># testnet</div>
          <div style="padding:5px 0 5px 0">- https://exchaintesttmrpc.fax.org</div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0"># mainnet</div>
          <div style="padding:5px 0 5px 0">Comming soon</div>
        </div>
      </div>
      <div class="p3">如果您运行自己的全节点，只需 <span>tcp://localhost:26657</span> 用作地址。</div>
      <div class="p3"><span>--trust-node</span> 然后，让我们设置标志的默认值：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config trust-node true</div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0"># Set to true if you trust the full-node you are connecting to, false otherwise</div>
        </div>
      </div>
      <div class="p3">最后，让我们设置 <span>chain-id</span> 要与之交互的区块链：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0"># testnet</div>
          <div style="padding:5px 0 5px 0">exchaincli config chain-id exchain-778787</div>
          <div style="padding:5px 0 5px 0"></div>
          <div style="padding:5px 0 5px 0"># mainnet</div>
          <div style="padding:5px 0 5px 0">exchaincli config chain-id exchain-778777</div>
        </div>
      </div>
      <div class="p3">设置 exchaincli 请求响应的输出格式</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">exchaincli config output json</div>
          <div style="padding:5px 0 5px 0">exchaincli config indent true</div>
        </div>
      </div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FAX 命令</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">设置 exchaincli</a></p>
      <!-- <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faxClient',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>